import React from "react";
import { useParams } from "react-router-dom";
import { getGameConfig } from "../games";
import { useGameplaySession } from "../hooks/useGameplaySession";
import MemoriaGame from "./MemoriaGame";

const Memoria = () => {
  const { date } = useParams();
  const gameConfig = getGameConfig('memoria');

  // Use the gameplay session hook
  const {
    state: sessionState,
    puzzleConfig,
    solutions, // Only available when game is complete
    status,
    gameOver,
    won,
    justLost,
    justWon, // True only when user wins during this session
    isLoading,
    error: sessionError,
    isEventPending,
    dispatchEvent,
    dispatchHintEvent,
    hintAllowance,
    refreshHintAllowance,
    isSignedIn,
  } = useGameplaySession(gameConfig.id, date);

  return (
    <MemoriaGame
      key={sessionState?.session_id || date}
      date={date}
      gameConfig={gameConfig}
      puzzleConfig={puzzleConfig}
      sessionState={sessionState}
      solutions={solutions}
      status={status}
      gameOver={gameOver}
      won={won}
      justLost={justLost}
      justWon={justWon}
      isLoading={isLoading}
      sessionError={sessionError}
      isEventPending={isEventPending}
      dispatchEvent={dispatchEvent}
      dispatchHintEvent={dispatchHintEvent}
      hintAllowance={hintAllowance}
      refreshHintAllowance={refreshHintAllowance}
      isSignedIn={isSignedIn}
    />
  );
};

export default Memoria;
